/**
 * TrafficServicesPage — CRUD hub for "المرور والترخيص" services.
 * Thin wrapper — all logic lives in <CategoryServicesPage />.
 */
import { Car } from 'lucide-react';
import CategoryServicesPage from './CategoryServicesPage';

const TRAFFIC_TYPE_OPTIONS = [
  { value: 'vehicle',  labelAr: 'مركبات',       labelEn: 'Vehicles' },
  { value: 'license',  labelAr: 'رخص القيادة',  labelEn: 'Driving Licenses' },
  { value: 'fine',     labelAr: 'مخالفات',      labelEn: 'Fines' },
  { value: 'test',     labelAr: 'اختبارات',     labelEn: 'Tests' },
  { value: 'transfer', labelAr: 'نقل ملكية',    labelEn: 'Transfer' },
  { value: 'other',    labelAr: 'أخرى',         labelEn: 'Other' },
];

const CONFIG = {
  apiPath: '/api/traffic-services',
  docsServiceType: 'traffic_services',
  listPath: '/control/cloudgm/traffic-services',
  typeOptions: TRAFFIC_TYPE_OPTIONS,
  defaultServiceType: 'vehicle',
  accent: '#F97316', // orange-500
  accentTw: {
    icon: 'text-orange-400',
    bg: 'bg-orange-500/10',
    border: 'border-orange-500/20',
    switchOn: 'data-[state=checked]:bg-orange-500',
    hoverBorder: 'hover:border-orange-500/50',
    hoverBg: 'hover:bg-orange-500/20',
  },
  pageIcon: Car,
  titleAr: 'خدمات المرور والترخيص',
  titleEn: 'Traffic & Licensing Services',
  subtitleAr: 'إدارة خدمات المرور وترخيص المركبات والسائقين',
  subtitleEn: 'Manage traffic, vehicle and driver licensing services',
  backPath: '/control/cloudgm?view=printing-documents',
  dataTestidPrefix: 'traffic',
  breadcrumb: [
    { labelAr: 'CLOUDGM FZ LLC', labelEn: 'CLOUDGM FZ LLC', path: '/dashboard?view=cloudgm' },
    { labelAr: 'منصة العملاء',    labelEn: 'Customers Platform', path: '/dashboard?view=cloudgm&platform=customers' },
    { labelAr: 'التحكم والمعلومات (منصة العملاء)', labelEn: 'Control & Info (Customers)', path: '/control/cloudgm' },
    { labelAr: 'الطباعة وتخليص المستندات', labelEn: 'Printing & Document Clearance', path: '/control/cloudgm?view=printing-documents' },
    { labelAr: 'المرور والترخيص', labelEn: 'Traffic & Licensing' },
  ],
};

export default function TrafficServicesPage() {
  return <CategoryServicesPage config={CONFIG} />;
}
